import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';

import reducers from '../reducers';

let store = applyMiddleware(thunkMiddleware)(createStore)(reducers);

if (process.env.NODE_ENV === 'development') {
    window.s = store;
}

export default store;



// WEBPACK FOOTER //
// ./web-app/store/index.js